import { render } from "./CrListPage.vue?vue&type=template&id=1ffaf926&scoped=true"
import script from "./CrListPage.vue?vue&type=script&lang=js"
export * from "./CrListPage.vue?vue&type=script&lang=js"

import "./CrListPage.vue?vue&type=style&index=0&id=1ffaf926&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffaf926"]])

export default __exports__